import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q1 = ({ history }) => {
  const { t } = useTranslation();
  const Q1Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 3,
        name: t('not_sure'),
        value: 'not_sure',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question1')}
      options={Q1Options}
      nextUrl="q2"
      screenName="q1"
      centered
    />
  );
};

export default Q1;
